module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-3.b6e4df7c.jpg";